import { castMapping } from "../../../constants/castMapping";

// sort castMapping by longer to shorter
castMapping.sort((a, b) => b.length - a.length);

/**
 * Fonction qui permet de préserver la casse originale des enregistrements
 * avec des corrections spécifiques si nécessaire
 */
export function formatQuery(query) {
    // Préserver la casse originale - plus de transformation automatique
    return query;
}

/**
 * Capitalise avec des règles spéciales pour les préfixes
 * Cette fonction est conservée pour compatibilité mais n'est plus utilisée par défaut
 */
export function capitalizeSpecial(word) {
    return word
        .split(" ") // Split the query into words
        .map((word) => {
            const prefix = castMapping.find((prefix) =>
                word.toUpperCase().startsWith(prefix),
            );
            if (prefix) {
                return prefix + word.slice(prefix.length).toLowerCase();
            } else {
                return (
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                );
            }
        })
        .join(" ");
}
